const lifeLessonQuotes = [
  "✨ Embrace the journey, not just the destination.",
  "🌱 Challenges are opportunities in disguise.",
  "💖 Kindness is free; sprinkle that stuff everywhere.",
  "🙅‍♀️ Learn to say 'no' without explaining yourself.",
  "🏆 Success is a series of small wins.",
  "🌀 Your vibe attracts your tribe.",
  "🎨 Take time to do what makes your soul happy.",
  "🎯 Mistakes are proof that you're trying.",
  "🌄 The only limit to our realization of tomorrow will be our doubts of today.",
];

const QuotesILiveBy = () => {
  return (
    <div
      style={{
        background: "linear-gradient(145deg, #1f1f1f, #2c2c2c)",
        color: "#f1f1f1",
        padding: "40px 20px",
        marginTop: "60px",
        borderTop: "1px solid #444",
        textAlign: "center",
        marginBottom: "100px",
      }}
    >
      <h2
        style={{ marginBottom: "30px", fontSize: "1.8rem", color: "#00e0ff" }}
      >
        Quotes I Live By
      </h2>
      <ul
        style={{
          listStyle: "none",
          padding: 0,
          maxWidth: "700px",
          margin: "0 auto",
        }}
      >
        {lifeLessonQuotes.map((quote, index) => (
          <li
            key={index}
            style={{
              marginBottom: "15px",
              padding: "12px 18px",
              background: "rgba(255, 255, 255, 0.05)",
              borderRadius: "12px",
              borderLeft: "4px solid #00e0ff",
              fontSize: "1rem",
              transition: "transform 0.2s ease",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.transform = "scale(1.02)")
            }
            onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
          >
            {quote}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default QuotesILiveBy;
